import { useLiveQuery } from 'dexie-react-hooks'
import { banco } from '../db/banco'
import { entradasDoPedido, estadoDoPedidoNaFila, type EstadoDoPedido } from '../sync/estadoDoPedido'
import { destravar } from '../sync/outbox'
import { enviarPendencias } from '../sync/sincronizador'

// As palavras sao as dela, do arquivo de sugestoes: "Pedido salvo no aparelho ·
// aguardando envio". O motivo que ela deu vale mais que o texto: "evita que o
// representante pense que o pedido foi perdido quando estiver sem internet".
const APARENCIA: Record<EstadoDoPedido, { bolinha: string; texto: string; cor: string }> = {
  sincronizado: {
    bolinha: 'bg-emerald-500',
    texto: 'Sincronizado',
    cor: 'text-slate-500',
  },
  aguardando: {
    bolinha: 'bg-amber-500',
    texto: 'Salvo no aparelho · aguardando envio',
    cor: 'text-amber-700',
  },
  travado: {
    bolinha: 'bg-red-500',
    texto: 'Não foi possível enviar',
    cor: 'text-red-700',
  },
}

export default function SeloDoPedido({ pedidoId }: { pedidoId: string }) {
  // useLiveQuery, nunca leitura unica: o que alimenta esta conta chega pela
  // sincronizacao, e num aparelho recem-aberto a resposta muda depois que a
  // tela ja montou. Este erro ja apareceu em CINCO telas deste projeto.
  const dados = useLiveQuery(async () => {
    const partes = await banco.sub_pedidos.where('pedido_id').equals(pedidoId).toArray()
    const fila = await banco.outbox.toArray()
    return { fila, idsDasPartes: partes.map((p) => p.id) }
  }, [pedidoId])

  // Enquanto o banco nao respondeu, nao dizer nada. Um "Sincronizado" mostrado
  // antes da resposta chegar seria a mentira mais cara desta tela -- e ela e
  // indistinguivel da verdade para quem esta olhando.
  if (!dados) return null

  const estado = estadoDoPedidoNaFila(dados.fila, pedidoId, dados.idsDasPartes)
  const { bolinha, texto, cor } = APARENCIA[estado]

  async function tentarDeNovo() {
    if (!dados) return
    const presas = entradasDoPedido(dados.fila, pedidoId, dados.idsDasPartes)
    for (const entrada of presas) await destravar(entrada.id)
    await enviarPendencias()
  }

  return (
    <p data-testid="selo-do-pedido" className={`flex items-center gap-1.5 text-xs mt-1 ${cor}`}>
      <span className={`inline-block w-2 h-2 rounded-full shrink-0 ${bolinha}`} />
      {texto}
      {estado === 'travado' && (
        <button
          type="button"
          data-testid="selo-tentar-de-novo"
          onClick={() => void tentarDeNovo()}
          className="underline font-bold"
        >
          Tentar de novo
        </button>
      )}
    </p>
  )
}
